import { render, staticRenderFns } from "./timer.vue?vue&type=template&id=527bf411&scoped=true&"
import script from "./timer.component.ts?vue&type=script&lang=ts&"
export * from "./timer.component.ts?vue&type=script&lang=ts&"
import style0 from "./timer.vue?vue&type=style&index=0&id=527bf411&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "527bf411",
  null
  
)

export default component.exports